module.exports = __webpack_public_path__ + "static/img/3.17ca087.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutus/3.jpg
// module id = FT/4
// module chunks = 1